<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Dashboard view for JbJobType entities with stats cards and QL widget table
-->
@if (initialized) {
    <div class="grid mt-2">

        <!-- Header -->
        <div class="col-12">
            <div class="flex justify-content-between py-2 px-4 surface-0 align-items-center shadow-1 border-round">
                <span class="text-lg font-semibold">Job-Typen</span>
            </div>
        </div>

        <!-- Stats Cards -->
        @if (stats?.length) {
            <div class="col-12">
                <div class="card p-3 shadow-1 border-round surface-0">
                    <div class="flex justify-content-between align-items-center">
                        @for (stat of stats; track stat.label; let first = $first) {
                            <div
                                class="flex flex-column flex-1 justify-content-center surface-border pl-4"
                                [class.border-left-1]="!first">
                                <div class="flex align-items-center">
                                    <i [class]="stat.icon + ' ' + stat.colorClass"></i>
                                    <small class="text-500 font-medium ml-2">{{ stat.label }}</small>
                                </div>
                                <div class="text-2xl font-bold mt-1">
                                    {{ stat.value }}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Action Panel (shown when a job type is selected) -->
        @if (selectedJobType) {
            <div class="col-12">
                <div class="card p-3 shadow-1 border-round surface-0">
                    <div class="flex justify-content-between align-items-center">
                        <div class="flex align-items-center gap-3">
                            <i class="fa-solid fa-briefcase text-primary text-xl"></i>
                            <div>
                                <div class="font-semibold">{{ selectedJobType.name }}</div>
                                <div class="text-sm text-500">
                                    Status: {{ getExecutionStatusLabel(selectedJobType.executionStatus) }}
                                    @if (selectedJobType.nextScheduledRunTime) {
                                        · Nächster Lauf: {{ selectedJobType.nextScheduledRunTime | date:'dd.MM.yyyy HH:mm' }}
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <p-button label="Jetzt ausführen" icon="fa-regular fa-play" severity="success"
                                      [loading]="actionBusy"
                                      [disabled]="selectedJobType.executionStatus === 2"
                                      (click)="onRunNow()">
                            </p-button>
                            @if (selectedJobType.executionStatus !== 1) {
                                <p-button [label]="selectedJobType.executionStatus === 2 ? 'Aktivieren' : 'Deaktivieren'"
                                          [icon]="selectedJobType.executionStatus === 2 ? 'fa-regular fa-circle-check' : 'fa-regular fa-ban'"
                                          [severity]="selectedJobType.executionStatus === 2 ? 'success' : 'warn'"
                                          [outlined]="true"
                                          [loading]="actionBusy"
                                          (click)="toggleJobStatus()">
                                </p-button>
                            }
                            <p-button icon="fa-regular fa-xmark" severity="secondary" [text]="true" [rounded]="true"
                                      pTooltip="Auswahl aufheben"
                                      (click)="clearSelection()">
                            </p-button>
                        </div>
                    </div>
                </div>
            </div>
        }

        <!-- Main Table Widget -->
        <div class="col-12">
            @if (jobTypeTableWidget) {
                <!-- AI: QL Widget table for JbJobType with create and row-click navigation -->
                <mvs-widget class="shadow-1 border-round block"
                            [widgetData]="jobTypeTableWidget"
                            (onObjectSelect)="handleObjectSelect($event)"
                ></mvs-widget>
            }
        </div>

    </div>
}
